import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_base_component = _resolveComponent("base-component")
  const _component_dialog_component = _resolveComponent("dialog-component")
  const _component_Tricube = _resolveComponent("Tricube")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.activityData)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          class: [_ctx.dialogData && 'filter-show']
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_component, {
      class: [_ctx.dialogData && 'filter-show']
    }, null, 8, ["class"]),
    (_ctx.dialogData)
      ? (_openBlock(), _createBlock(_component_dialog_component, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Tricube)
  ], 64))
}